import React from "react";
import CinematicPlayer from "@features/cinematic/CinematicPlayer";
import "../features/cinematic/styles/cinematic.css";

export function SimulatorPage() {
  return (
    <div style={styles.root}>
      <CinematicPlayer />
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  root: {
    height: "100vh",
    width: "100%",
    overflow: "hidden",
    background: "#000000",
    color: "#E6EDF3"
  }
};